import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { CssBaseline, Grid, IconButton } from '@material-ui/core';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import Topbar from '../components/Topbar';
import SatelliteItem from './SateliteItem';
import './Satellite.css';
import EventDialog from '../components/dialogs/EventDialog';
import ProgramDialog from '../components/dialogs/ProgramDialog';
import VideoDialog from '../components/dialogs/VideoDialog';
import axios from 'axios';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { API_URL, EVENT_ID, getUserID, EVENT_IMG } from '../constants';
import swal from 'sweetalert';

const styles = (theme) => ({
  root: {
    height: '100%',
    position: 'relative',
    backgroundPosition: 'center',
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
  },
  main: {
    height: 'calc(100% - 84px)',
    overflowY: 'auto',

    display: 'flex',
    backgroundColor: 'rgba(0,0,0,0.5)',
    backgroundImage: `url('/images/ksic2022/main_background.jpg')`,
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
    // backgroundPosition: '50% -40px',
    [theme.breakpoints.down('sm')]: {
      backgroundImage: 'none',
    },
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      position: 'relative', //ie overflow hidden bug fix
    },
  },
  modalDiv: {
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  black: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  modalWrap: {
    padding: '70px 0 30px',
    [theme.breakpoints.down('md')]: {
      padding: '0 0 30px',
    },
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      width: '85vw',
    },
  },
  closeBtnGrid: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  modalGrid: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      height: '100%',
    },
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      height: 'auto',
    },
  },
  modalPoster: {
    width: '60vw',
    borderRadius: '10px',
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      minWidth: '960px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '77%',
      margin: '20px 0',
    },
    backgroundColor: '#fff',
    textAlign: 'center',
    overflow: 'hidden',
    height: 'fit-content',
  },

  headlineTxt: {
    margin: 0,
    padding: '20px 0',
    fontSize: '26px',
    color: theme.palette.primary.main,
  },

  ulWrap: {
    [theme.breakpoints.down('sm')]: {
      overflow: 'auto',
    },
  },

  sponsor_logo: {
    width: '100%',
    height: '100%',
  },
  satellitesUl: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: '0',
  },

  companyList: {
    width: '25%',
    marginBottom: '30px',
  },
  listInner: {
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      [theme.breakpoints.down('xs')]: {
        height: '100px',
      },
    },
  },
  eventCompletePopup: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    '& img': {
      cursor: 'pointer',
    },
    [theme.breakpoints.down('xs')]: {
      width: '90%',
    },
  },
  imgComplete: {
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      width: '100%',
    },
  },
  evtTxt: {
    color: '#F81137',
    fontWeight: 'bold',
    position: 'absolute',
    top: '72%',
    width: '100%',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
});

class Satellite extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    const { cookies } = this.props;

    this.state = {
      openEventPopup: cookies.get(getUserID(true) + '_satelliteWatched') ? false : true,
      programDialog: false,
      videoDialog: false,
      completePopup: false,
      selectedIndex: 0,
      satellitesData: [],
    };
  }

  getSatelliteList() {
    axios.get(`${API_URL}/satellite/?evt=${EVENT_ID}&limit=-1`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      this.setState({ satellitesData: response.data });
    });
  }
  componentDidMount() {
    this.getSatelliteList();
  }
  closeEventDialog = (event) => {
    this.setState({ openEventPopup: false });
  };
  changeIndex = (type, newIndex) => {
    this.setState({ selectedIndex: newIndex });
    if (type === 'video') {
      this.openVideoDialog();
    }
    if (type === 'program') {
      this.openProgramDialog();
    }
  };
  openProgramDialog = (event) => {
    this.setState({ programDialog: true });
  };
  closeProgramDialog = (event) => {
    this.setState({ programDialog: false });
  };

  openVideoDialog = (event) => {
    this.setState({ videoDialog: true });
  };
  closeVideoDialog = (event) => {
    this.setState({ videoDialog: false });
  };

  openCompletePopup = (event) => {
    this.setState({ completePopup: true });
  };
  closeCompletePopup = (event) => {
    this.setState({ completePopup: false });
  };

  onVodPlay = () => {
    const { cookies } = this.props;
    const satellite = this.state.satellitesData[this.state.selectedIndex];
    let isFirst = false;
    if (!sessionStorage.getItem('firstEnterSatellite_' + satellite.id)) {
      isFirst = true;
      sessionStorage.setItem('firstEnterSatellite_' + satellite.id, true);
    }
    if (
      !cookies.get(getUserID(true) + '_satelliteWatched') &&
      (navigator.userAgent.toLowerCase().indexOf('iphone') !== -1 ||
        navigator.userAgent.toLowerCase().indexOf('android') !== -1 ||
        navigator.userAgent.toLowerCase().indexOf('mobile') !== -1)
    ) {
      swal('모바일에서 Full Screen으로 시청 시 이벤트 응모 불가합니다.');
    }

    let param = {
      eventId: EVENT_ID,
      pgmId: satellite.id,
      userid: getUserID(true),
      pgmInfo: satellite,
      isFirst: isFirst,
      username: sessionStorage.getItem('_in_name'),
      position: sessionStorage.getItem('_in_position'),
    };
    axios.post(`${API_URL}/satellite/view`, param).then((response) => {});
  };

  onVodComplete = () => {
    const { cookies } = this.props;
    const satellite = this.state.satellitesData[this.state.selectedIndex];
    let param = {
      eventId: EVENT_ID,
      satelliteId: satellite.id,
      name: satellite.name,
      userid: getUserID(true),
      satellite: satellite,
      username: sessionStorage.getItem('_in_name'),
      position: sessionStorage.getItem('_in_position'),
    };
    axios.post(`${API_URL}/satellite/event`, param).then((response) => {
      if (!cookies.get(getUserID(true) + '_satelliteWatched')) {
        cookies.set(getUserID(true) + '_satelliteWatched', true);
        this.setState({ completePopup: true, openEventPopup: false });
      } else {
        this.setState({ completePopup: false, openEventPopup: false });
      }
    });
  };

  render() {
    const { classes } = this.props;
    const currentPath = this.props.location.pathname;
    const mapToComponent = (datas) => {
      return datas.map((satellite, i) => {
        return (
          <Grid
            item
            container
            justifyContent="center"
            alignItems="center"
            xs={12}
            md={3}
            className={classes.companyList}
            key={i}
            style={window.matchMedia('(min-width: 960px)').matches ? { maxWidth: '20%', flexBasis: '20%', width: '20%' } : {}}
          >
            <div className={classes.listInner} style={{ width: '90%' }}>
              <SatelliteItem
                satellite={satellite}
                changeIndex={this.changeIndex}
                openProgramDialog={this.openProgramDialog}
                openVideoDialog={this.openVideoDialog}
                satelliteIndex={i}
              />
            </div>
          </Grid>
        );
      });
    };

    return (
      <React.Fragment>
        <CssBaseline />
        <Topbar currentPath={currentPath} />
        <Grid container justifyContent="center" className={classes.main}>
          <img src={`${EVENT_IMG}/black.png`} className={classes.black} alt="" />
          <div className={classes.modalWrap}>
            <Grid item xs={12} className={classes.closeBtnGrid}>
              <div style={{ width: '60vw', minWidth: '960px', textAlign: 'right' }}>
                <IconButton
                  onClick={() => {
                    this.props.history.push('main');
                  }}
                >
                  <CloseRoundedIcon style={{ fontSize: '38px', color: '#ffffff' }} />
                </IconButton>
              </div>
            </Grid>
            <Grid item xs={12} className={classes.modalGrid}>
              <div className={classes.modalPoster}>
                <h2 className={classes.headlineTxt}>Satellite Session</h2>
                <div className={classes.boothsWrap}>
                  <div className={classes.ulWrap}>
                    <Grid container className={classes.satellitesUl}>
                      {mapToComponent(this.state.satellitesData)}
                    </Grid>
                  </div>
                </div>
              </div>
            </Grid>
          </div>
          {this.state.completePopup && (
            <div
              className={classes.eventCompletePopup}
              style={
                window.matchMedia('(max-width: 600px)').matches
                  ? { zIndex: 9999, height: 'calc(100% - 87.5px)' }
                  : { zIndex: 9999, height: 'calc(100% - 84px)' }
              }
            >
              <div style={{ width: '100%', position: 'relative', zIndex: 9999 }} onClick={this.closeCompletePopup}>
                <img
                  src={'/images/ksic2021/satellite_event_complete.png'}
                  style={
                    window.matchMedia('(max-width: 600px)').matches ? { zIndex: 9999, width: '100%', height: 'auto' } : { zIndex: 9999 }
                  }
                  className={classes.imgComplete}
                  alt=""
                />
              </div>
            </div>
          )}
        </Grid>
        <EventDialog open={this.state.openEventPopup} onClose={this.closeEventDialog} disableBackdrop={true} />
        <ProgramDialog
          open={this.state.programDialog}
          onClose={this.closeProgramDialog}
          openProgramDialog={this.openProgramDialog}
          disableBackdrop={false}
          selectedIndex={this.state.selectedIndex}
          satellitesData={this.state.satellitesData}
        />
        <VideoDialog
          satellitesData={this.state.satellitesData}
          open={this.state.videoDialog}
          onClose={this.closeVideoDialog}
          disableBackdrop={false}
          selectedIndex={this.state.selectedIndex}
          onComplete={this.onVodComplete}
          onPlay={this.onVodPlay}
        />
      </React.Fragment>
    );
  }
}
export default withCookies(withStyles(styles, { withTheme: true })(Satellite));
